export default __webpack_public_path__ + "static/media/twitter.7bbb4f69.svg";